import { useTranslation } from 'react-i18next'

import { FormikField, getFormikFormFieldErrorProps } from '../../../Formik'
import { TextareaOutlineField } from '../../../Textarea'
import {
  PROFILE_INFO_NOTES_FIELD_NAME,
  PROFILE_INFO_NOTES_LABEL_KEY,
  PROFILE_INFO_NOTES_MAX_LENGTH,
} from '../ProfileInfoWidget.constants'

function ProfileInfoWidgetNotesField() {
  const { t } = useTranslation()

  return (
    <FormikField
      clearable
      withoutManualResize
      Component={TextareaOutlineField}
      getErrorProps={getFormikFormFieldErrorProps}
      label={t(PROFILE_INFO_NOTES_LABEL_KEY)}
      maxLength={PROFILE_INFO_NOTES_MAX_LENGTH}
      name={PROFILE_INFO_NOTES_FIELD_NAME}
    />
  )
}

export default ProfileInfoWidgetNotesField
